<template>
  <div>
    <v-main>
      <div>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-card rounded="t-xl">
                  <v-list three-line subheader>
                    <!-- <v-card-title class="header_1">
                                    ข้อมูลที่อยู่
                                    <v-icon color="#871B12">mdi-account-circle-outline </v-icon>
                                </v-card-title> -->
                    <v-app-bar fixed app no-gutters color="indigo" dark>
                      <v-toolbar-title>ข้อมูลที่อยู่</v-toolbar-title>

                      <v-col class="text-right">
                        <v-btn icon @click="closePage()">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-app-bar>
                    <br />

                    <v-col class="pa-2" v-if="dataAddress.length !== 2">
                      <v-alert
                        border="right"
                        colored-border
                        type="error"
                        elevation="20"
                      >
                      กรุณากรอกข้อมูลให้ครบถ้วนเพื่อสิทธิประโยชน์ของท่าน
                      <br>เพิ่มข้อมูลที่อยู่ ให้ครบสองประเภท
                      ที่อยู่ปัจจุบันและที่อยู่ตามบัตรประชาชน
                      </v-alert>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        v-if="dataAddress.length < 2"
                        color="primary"
                        depressed
                        @click="
                          (dialogAdd = true), validate('ADD'), clearData()
                        "
                      >
                        <v-icon left>mdi-text-box-plus</v-icon>
                        เพิ่มข้อมูล
                      </v-btn>
                    </v-col>
                    <!-- ADD -->
                    <v-dialog v-model="dialogAdd" fullscreen>
                      <v-card>
                        <v-toolbar color="indigo" dark>
                          <v-toolbar-title>เพิ่มข้อมูลที่อยู่</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn
                            icon
                            dark
                            @click="(dialogAdd = false), clearData()"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-toolbar>
                        <v-card-text>
                          <v-container>
                            <v-form
                              ref="form_add"
                              v-model="valid_add"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-select
                                    :items="address_status"
                                    v-model="formAdd.empAddressStatus"
                                    :rules="nameRules"
                                    label="ประเภทที่อยู่"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-textarea
                                    rows="3"
                                    row-height="25"
                                    label="ที่อยู่ *"
                                    v-model="formAdd.empAddressName"
                                    :rules="nameRules"
                                    :counter="500"
                                    maxlength="500"
                                    required
                                    dense
                                    outlined
                                    hint="* กรุณากรอกที่อยู่ตามรูปแบบนี้  'บ้านเลขที่  หมู่ที่ หมู่บ้าน/ตึกอาคาร ซอย/ถนน *'"
                                    persistent-hint
                                  ></v-textarea>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="formAdd.empAddressZipcode"
                                    :rules="nameRules"
                                    @input="getAddress(formAdd)"
                                    label="รหัสไปรษณีย์ *"
                                    :counter="5"
                                    maxlength="5"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="formAdd.empAddressProvine"
                                    :rules="nameRules"
                                    label="จังหวัด"
                                    :counter="50"
                                    maxlength="50"
                                    readonly
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="optionDistrict"
                                    v-model="formAdd.empAddressDistrict"
                                    :rules="nameRules"
                                    label="อำเภอ/เขต"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="optionSupDistrict"
                                    v-model="formAdd.empAddressSubDistrict"
                                    :rules="nameRules"
                                    :counter="50"
                                    maxlength="50"
                                    label="ตำบล/แขวง"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="AddressType"
                                    v-model="formAdd.empAddressType"
                                    :rules="nameRules"
                                    label="ประเภทที่พัก"
                                    required
                                    dense
                                    outlined
                                    placeholder="Select..."
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-checkbox
                                    v-model="formAdd.empAddessStatusMessenger"
                                    :label="`ที่อยู่จัดส่งไปรษณีย์`"
                                  ></v-checkbox>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-checkbox
                                    v-model="formAdd.empAddressVerifyInfo"
                                    :label="`*ยินยอมให้บริการข้อมูลนี้ เพื่อเข้าร่วมโครงการ`"
                                    false-value="False"
                                    true-value="True"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-card-actions>
                              <v-col class="text-center">
                                <v-btn
                                  elevation="2"
                                  x-large
                                  color="success"
                                  text
                                  :disabled="!valid_add"
                                  @click="addData()"
                                >
                                  <v-icon left
                                    >mdi-checkbox-marked-circle</v-icon
                                  >
                                  เพิ่มข้อมูล
                                </v-btn>
                              </v-col>
                            </v-card-actions>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <!-- end add -->
                    <!-- <v-divider color="#871B12"></v-divider> -->
                    <div v-for="(items, index) in dataAddress" :key="index">
                      <v-card elevation="20" v-if="dataReady">
                        <v-card-title>
                          <strong>{{ items.empAddressStatus }}</strong>
                          <v-icon color="#871B12"
                            >mdi-home-circle-outline
                          </v-icon>
                        </v-card-title>
                        <v-divider color="#871B12"></v-divider>
                        <v-card-text>
                          <v-form
                            ref="form_update"
                            v-model="valid_update"
                            lazy-validation
                          >
                            <v-container class="py-0">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-textarea
                                    rows="3"
                                    row-height="25"
                                    label="ที่อยู่ *"
                                    v-model="items.empAddressName"
                                    :rules="nameRules"
                                    :counter="500"
                                    maxlength="500"
                                    required
                                    dense
                                    outlined
                                    hint="* บ้านเลขที่  หมู่ที่ หมู่บ้าน/ตึกอาคาร ซอย/ถนน *"
                                    persistent-hint
                                  ></v-textarea>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.empAddressZipcode"
                                    :rules="nameRules"
                                    @input="getAddressByGet(items)"
                                    label="รหัสไปรษณีย์ * "
                                    :counter="5"
                                    maxlength="5"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.empAddressProvine"
                                    label="จังหวัด"
                                    :rules="nameRules"
                                    :counter="50"
                                    maxlength="50"
                                    readonly
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="items.optionDistrictByGet"
                                    v-model="items.empAddressDistrict"
                                    :rules="nameRules"
                                    :counter="50"
                                    maxlength="50"
                                    label="อำเภอ/เขต"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="items.optionSupDistrictByGet"
                                    v-model="items.empAddressSubDistrict"
                                    :rules="nameRules"
                                    :counter="50"
                                    maxlength="50"
                                    label="ตำบล/แขวง"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="AddressType"
                                    v-model="items.empAddressType"
                                    label="ประเภทที่พัก"
                                    :rules="nameRules"
                                    required
                                    dense
                                    outlined
                                    placeholder="Select..."
                                  ></v-select>
                                </v-col>

                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="items.empAddessStatusMessenger"
                                    :label="`ที่อยู่จัดส่งไปรษณีย์`"
                                    false-value="False"
                                    true-value="True"
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="items.empAddressVerifyInfo"
                                    :label="`*ยินยอมให้บริการข้อมูลนี้ เพื่อเข้าร่วมโครงการ`"
                                    false-value="False"
                                    true-value="True"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>

                              <v-col class="text-right">
                                <v-btn
                                  small
                                  color="success"
                                  class="mr-0"
                                  :disabled="items.empAddressVerifyInfo == 'False'"
                                  @click="editDataAddress(items)"
                                >
                                  บันทึกข้อมูล
                                </v-btn>
                              </v-col>
                            </v-container>
                          </v-form>
                        </v-card-text>
                      </v-card>
                      <br />
                      <br />
                    </div>
                    <br />
                  </v-list>
                </v-card>
                <v-row no-gutters>
                  <v-footer fixed height="60px" color="#262A34">
                    <v-col class="text-right">
                      <v-btn small color="#E0E0E0" @click="pushBack">
                        <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn small color="#E0E0E0" @click="pushNext">
                        หน้าถัดไป
                        <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                  </v-footer>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import addressTypeNameTH from '../../assets/master/AddressType/addressTypeTH.json'
export default {
  components: {},
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      // rollHR: false,
      path: '/employee_address_event_punsuk/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      valid_add: true,
      valid_update: true,
      checkbox: false,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      dialogAdd: false,
      address_status: ['ที่อยู่ปัจจุบัน', 'ที่อยู่ตามบัตรประชาชน'],

      formAdd: [],
      dataAddress: [],
      nameRules: [(v) => !!v || 'โปรดให้ข้อมูลตามความเป็นจริง'],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      AddressType: addressTypeNameTH,
      optionDistrict: [],
      optionSupDistrict: [],
      dataEmp: '',
      can: true,
      profile: []
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    await this.getDataByAddress()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataByAddress () {
      this.dataAddress = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee_address_event_punsuk/getEmpCode?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            let rs = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              // if (!this.rollHR) {
              //   if (d.empAddressStatus === 'ที่อยู่ตามบัตรประชาชน') {
              //     d.checkReadOnly = true
              //   } else {
              //     if (!this.can) {
              //       d.checkReadOnly = true
              //     } else {
              //       d.checkReadOnly = false
              //     }
              //   }
              // } else {
              //   if (!this.can) {
              //     d.checkReadOnly = true
              //   } else {
              //     d.checkReadOnly = false
              //   }
              // }
              d.optionDistrictByGet = []
              d.optionSupDistrictByGet = []
              this.dataAddress.push(d)
              await this.getAddressByGet(d)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getAddressByGet (dt) {
      if (dt.empAddressZipcode.length >= 5) {
        dt.optionSupDistrictByGet = []
        dt.optionDistrictByGet = []
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/location/map_thai/?zipcode=" + dt.empAddressZipcode,
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }
          )
          .then(async (response) => {
            dt.empAddressProvine = response.data[0].province
            let rs = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.sub_district
              s.value = d.sub_district
              dt.optionSupDistrictByGet.push(s)
              var s1 = {}
              s1.text = d.district
              s1.value = d.district
              dt.optionDistrictByGet.push(s1)
            }
          })
      }
    },
    async getAddress (dt) {
      if (dt.empAddressZipcode.length >= 5) {
        this.optionDistrict = []
        this.optionSupDistrict = []
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/location/map_thai/?zipcode=' +
              this.formAdd.empAddressZipcode
          )
          .then(async (response) => {
            this.formAdd.empAddressProvine = response.data[0].province
            let rs = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.sub_district
              s.value = d.sub_district
              this.optionSupDistrict.push(s)
              var s1 = {}
              s1.text = d.district
              s1.value = d.district
              this.optionDistrict.push(s1)
            }
          })
      }
    },
    async addData () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ บันทึกข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            empCode: this.profile.empCode,
            empAddressName: this.formAdd.empAddressName,
            empAddressStatus: this.formAdd.empAddressStatus,
            empAddessStatusMessenger: this.formAdd.empAddessStatusMessenger,
            empAddressVerifyInfo: this.formAdd.empAddressVerifyInfo,
            empAddressSubDistrict: this.formAdd.empAddressSubDistrict,
            empAddressDistrict: this.formAdd.empAddressDistrict,
            empAddressProvine: this.formAdd.empAddressProvine,
            empAddressZipcode: this.formAdd.empAddressZipcode,
            empAddressType: this.formAdd.empAddressType,
            CREATE_USER: this.profile.userName,
            LAST_USER: this.profile.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              ds
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false
              this.getDataByAddress()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async editDataAddress (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.empAddressID
          let ds = {
            empAddressName: dt.empAddressName,
            empAddessStatusMessenger: dt.empAddessStatusMessenger,
            empAddressVerifyInfo: dt.empAddressVerifyInfo,
            empAddressSubDistrict: dt.empAddressSubDistrict,
            empAddressDistrict: dt.empAddressDistrict,
            empAddressProvine: dt.empAddressProvine,
            empAddressZipcode: dt.empAddressZipcode,
            empAddressType: dt.empAddressType,
            empAddressStatus: dt.empAddressStatus,
            LAST_USER: this.profile.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              this.getDataByAddress()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function submitEditAddress : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async clearData () {
      this.formAdd = []
      if (this.dataAddress.length < 2) {
        this.dataAddress.forEach((element) => {
          var myIndex = this.address_status.indexOf(element.empAddressStatus)
          if (myIndex !== -1) {
            this.address_status.splice(myIndex, 1)
          }
        })
      }
    },
    closePage () {
      this.$router.push('/Liff/HomeEmployee')
    },
    async pushNext () {
      if (this.dataAddress.length > 0) {
        // this.$swal({
        //   title: 'บันทึกการ แก้ไขข้อมูล ใช่หรือไม่?',
        //   type: 'question',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#b3b1ab',
        //   confirmButtonText: 'ใช่',
        //   cancelButtonText: 'ไม่'
        // })
        //   .then(async (result) => {
        this.dataReady = false
        this.dataAddress.forEach(async (element) => {
          let ds = {
            empAddressID: element.empAddressID,
            empAddressName: element.empAddressName,
            empAddessStatusMessenger: element.empAddessStatusMessenger,
            empAddressVerifyInfo: element.empAddressVerifyInfo,
            empAddressSubDistrict: element.empAddressSubDistrict,
            empAddressDistrict: element.empAddressDistrict,
            empAddressProvine: element.empAddressProvine,
            empAddressZipcode: element.empAddressZipcode,
            empAddressType: element.empAddressType,
            empAddressStatus: element.empAddressStatus,
            LAST_USER: this.profile.userName
          }
          console.log('ds', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "update",
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.dataReady = true
              // this.$router.push('/Liff/EmpInfomation')
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        // })
        // .catch((error) => {
        //   this.dataReady = true
        //   console.log('error function editDataGlobal : ', error)
        // })
      }
      this.dataReady = true
      await this.$router.push('/Liff/EmpInfomation')
    },
    async pushBack () {
      console.log('back dataAddress', this.dataAddress)
      if (this.dataAddress.length > 0) {
        // this.$swal({
        //   title: 'บันทึกการ แก้ไขข้อมูล ใช่หรือไม่?',
        //   type: 'question',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#b3b1ab',
        //   confirmButtonText: 'ใช่',
        //   cancelButtonText: 'ไม่'
        // })
        //   .then(async (result) => {
        this.dataReady = false
        this.dataAddress.forEach(async (element) => {
          let ds = {
            empAddressID: element.empAddressID,
            empAddressName: element.empAddressName,
            empAddessStatusMessenger: element.empAddessStatusMessenger,
            empAddressVerifyInfo: element.empAddressVerifyInfo,
            empAddressSubDistrict: element.empAddressSubDistrict,
            empAddressDistrict: element.empAddressDistrict,
            empAddressProvine: element.empAddressProvine,
            empAddressZipcode: element.empAddressZipcode,
            empAddressType: element.empAddressType,
            empAddressStatus: element.empAddressStatus,
            LAST_USER: this.profile.userName
          }
          console.log('ds', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "update",
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.dataReady = true
              // this.$router.push('/Liff/EmpFamily')
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        // })
        // .catch((error) => {
        //   this.dataReady = true
        //   console.log('error function editDataGlobal : ', error)
        // })
      }
      this.dataReady = true
      await this.$router.push('/Liff/EmpFamily')
    }
  }
}
</script>

<style>
.scroll {
  overflow-y: scroll;
}

.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/EmpAddress.vue